import { render, staticRenderFns } from "./contenido-md.vue?vue&type=template&id=8b47fa38&"
import script from "./contenido-md.vue?vue&type=script&lang=js&"
export * from "./contenido-md.vue?vue&type=script&lang=js&"
import style0 from "./contenido-md.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports